import React from 'react';
import PropTypes from 'prop-types';
import AppStack from '../../common/AppStack';
import AppCard from '../../common/AppCard';
import PrintDesignEditorProductSidebarItem from './PrintDesignEditorProductSidebarItem';
import ConfirmModal from '../../common/ConfirmModal';
import AppText from '../../common/AppText';

const PrintDesignEditorProductSidebar = ({
  productIds,
  ecomExternalProducts,
  loading,
  formState,
  setFormState,
  printTemplateState,
  setPrintTemplateState
}) => (
  <AppStack
    style={{ flex: 1, maxWidth: 250, height: '100%', overflow: 'hidden' }}
  >
    <AppCard
      radius={0}
      style={{
        padding: 0,
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        overflow: 'hidden',
        borderRight: 'solid 1px lightgrey'
      }}
    >
      <AppStack
        style={{
          padding: 8,
          gap: 8,
          height: '100%',
          width: '100%',
          maxWidth: '100%',
          overflow: 'auto'
        }}
      >
        {loading || ecomExternalProducts.length === 0
          ? Array.from({ length: productIds?.length ?? 3 }).map((_, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <PrintDesignEditorProductSidebarItem key={index} />
            ))
          : ecomExternalProducts
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((p) => (
                <PrintDesignEditorProductSidebarItem
                  key={p.id}
                  ecomVendorProduct={p}
                  formState={formState}
                  setFormState={setFormState}
                />
              ))}
      </AppStack>
    </AppCard>

    {formState.confirmSelectedTemplateId && (
      <ConfirmModal
        isOpen={!!formState.confirmSelectedTemplateId}
        onCancel={() => {
          setFormState((prev) => ({
            ...prev,
            confirmSelectedTemplateId: null
          }));
        }}
        onConfirm={() => {
          setFormState((prev) => ({
            ...prev,
            confirmSelectedTemplateId: null,
            selectedProductDesignId:
              prev.selectedProductDesignId === prev.confirmSelectedTemplateId
                ? null
                : prev.selectedProductDesignId,
            productDesigns: prev.productDesigns.filter(
              (p) => p.id !== prev.confirmSelectedTemplateId
            )
          }));
          if (printTemplateState.id === formState.confirmSelectedTemplateId) {
            setPrintTemplateState((prev) => ({
              ...prev,
              id: null,
              canvasState: null
            }));
          }
        }}
        title="Remove print design?"
      >
        <AppText style={{ fontSize: 14 }}>
          Are you sure you want to remove this print design?
        </AppText>
      </ConfirmModal>
    )}
  </AppStack>
);

PrintDesignEditorProductSidebar.propTypes = {
  ecomExternalProducts: PropTypes.array.isRequired,
  formState: PropTypes.object.isRequired,
  printTemplateState: PropTypes.object.isRequired,
  productIds: PropTypes.array.isRequired,
  setFormState: PropTypes.func.isRequired,
  setPrintTemplateState: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

export default PrintDesignEditorProductSidebar;
